export default "__VITE_ASSET__oqKveKqA__"